import * as React from 'react'
import { Box, Typography, Container, Link } from '@material-ui/core'

function Copyright() {
  return (
    <Typography
      variant='body2'
      color='text.secondary'
      style={{ textAlign: 'center' }}
    >
      {'Copyright © '}
      <Link color='inherit' href='https://oyeeah.com/'>
        Oyeeah
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  )
}

export default function Footer() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '70vh',
      }}
    >
      <Box
        component='footer'
        sx={{
          py: 2,
          px: 2,
          mt: 'auto',
          backgroundColor: (theme) =>
            theme.palette.mode === 'light'
              ? theme.palette.white[200]
              : theme.palette.white[800],
        }}
      >
        <Container maxWidth='sm'>
          <Copyright />
        </Container>
      </Box>
    </Box>
  )
}
